<template>
	<div v-if="pages != null && pagination != null" class="flex items-center">
		<button
			:class="[
				pagination.current_page == 1 || pages.length == 1
					? 'stroke-grey-700'
					: 'stroke-black',
			]"
			:disabled="pagination.current_page == 1 || pages.length == 1"
			class="text-14 font-medium w-4.5 h-4.5 transition-colors duration-300 hover:stroke-grey-700 mr-2.5"
			@click.stop="change(1)"
		>
			<IconArrowDoubleLeft class="h-4.5 w-4.5" />
		</button>

		<button
			:class="[
				pagination.current_page == 1 || pages.length == 1
					? 'stroke-grey-700'
					: 'stroke-black',
			]"
			:disabled="pagination.current_page == 1 || pages.length == 1"
			class="text-14 font-medium w-4.5 h-4.5 transition-colors duration-300 hover:stroke-grey-700 mr-4"
			@click.stop="change(pagination.current_page - 1)"
		>
			<IconArrowLeft class="h-4.5 w-4.5" />
		</button>

		<!-- <button class='w-8 h-6 text-14 text-grey-700 font-medium hover:text-black transition-colors duration-300'
			v-if='pages[0] > 2'
			@click='change(1)'
			v-text='"1"'
		/> -->

		<!-- <button class='w-8 h-6 text-14 text-grey-800 font-medium !cursor-default'
			v-if='pages[0] > 2'
			v-text='"..."'
		/> -->

		<button
			v-for="page in pages"
			:key="page"
			:class="[
				page == pagination.current_page
					? 'text-black'
					: 'text-grey-700',
			]"
			class="w-8 h-6 text-14 font-medium hover:text-black transition-colors duration-300"
			@click.stop="change(page)"
		>
			{{ page }}
		</button>

		<!-- <button class='w-8 h-6 text-14 text-grey-800 font-medium !cursor-default'
			v-if='pages[pages.length-1] < (pagination.last_page - 1)'
			v-text='"..."'
		/> -->

		<!-- <button class='w-8 h-6 text-14 text-grey-700 font-medium'
			v-if='pages[pages.length-1] < (pagination.last_page - 1)'
			@click='change(pagination.last_page)'
			v-text='pagination.last_page'
		/> -->

		<button
			:class="[
				pagination.current_page == pagination.last_page ||
				pages.length == 1
					? 'stroke-grey-700'
					: 'stroke-black',
			]"
			:disabled="
				pagination.current_page == pagination.last_page ||
				pages.length == 1
			"
			class="text-14 font-medium stroke-black w-4.5 h-4.5 transition-colors duration-300 hover:stroke-grey-700 ml-4"
			@click.stop="change(pagination.current_page + 1)"
		>
			<IconArrowRight class="h-4.5 w-4.5" />
		</button>

		<button
			:class="[
				pagination.current_page == pagination.last_page ||
				pages.length == 1
					? 'stroke-grey-700'
					: 'stroke-black',
			]"
			:disabled="
				pagination.current_page == pagination.last_page ||
				pages.length == 1
			"
			class="text-14 font-medium stroke-black w-4.5 h-4.5 transition-colors duration-300 hover:stroke-grey-700 ml-2.5"
			@click.stop="change(pagination.last_page)"
		>
			<IconArrowDoubleRight class="h-4.5 w-4.5" />
		</button>
	</div>
</template>

<script>
export default {
	props: {
		pagination: {
			type: Object,
		},
		page: Object,
		offset: {
			type: Number,
			default: 2,
		},
	},

	computed: {
		pages() {
			if (this.pagination == null) {
				return [1];
			}

			if (!this.pagination.to) {
				return [1];
			}

			let from = this.pagination.current_page - this.offset;
			if (from < 1) {
				from = 1;
			}
			let to = from + this.offset * 2;
			if (to >= this.pagination.last_page) {
				to = this.pagination.last_page;
			}
			let pages = [];
			for (let page = from; page <= to; page++) {
				pages.push(page);
			}
			return pages;
		},
	},

	methods: {
		change: function (page) {
			this.page.set("page", page).updated({
				scollBottom: true,
			});
		},
	},
};
</script>
